import Vue from 'vue'
import axios from './vue-axios/axios'
import moment from 'moment'

export function unavailabilityDateList(userId = null, filter_params = {}) {
  let params = userId ? { id: userId, filters: filter_params } : { filters: filter_params }
  return Vue.axios.get('/v1/unavailability_dates', { params: params,
    paramsSerializer: function(params) {
      return $.param(params)
    }
  })
}

export function unavailabilityDateCount(userId = null, filter_params = {}) {
  let params = userId ? { id: userId, filters: filter_params } : { filters: filter_params }
  return Vue.axios.get('/v1/unavailability_dates/count_by_dates', { params: params,
    paramsSerializer: function(params) {
      return $.param(params)
    }
  })
}

export function createNewUnavailabilityDate(unavailabilityDateParams) {
  return Vue.axios.post('/v1/unavailability_dates', { unavailability_date: unavailabilityDateParams })
}

export function deleteUnavailabilityDate(unavailabilityDateID) {
  return Vue.axios.delete('/v1/unavailability_dates/' + unavailabilityDateID)
}

export function updateUnavailabilityDate(unavailabilityDateParams) {
  return Vue.axios.put('/v1/unavailability_dates/' + unavailabilityDateParams.id, { unavailability_date: unavailabilityDateParams })
}

export function unavailabilityDateScheduled(params) {
  return Vue.axios.get('/v1/unavailability_dates/schedule', {params: params})
}



// WEBPACK FOOTER //
// ./src/backend/unavailabilityDates.js